var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('restaurant-detail',{staticClass:"restaurant-address",attrs:{"title":"address"}},[_c('address',{directives:[{name:"test",rawName:"v-test:address",arg:"address"}]},[_vm._v("\n        "+_vm._s(_vm.address)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }